module.exports = __webpack_public_path__ + "img/h2.8b611c9d.jpg";